module.exports = __webpack_public_path__ + "img/zhengce.0e31358f.png";